import React from 'react';
import * as ReactRedux from 'react-redux';
import PropTypes from 'prop-types';
import AnimationConstants from 'Animation/AnimationConstants';
import ProgressBar from 'ProgressBar';

class StaticBuilderSaveProgressBar extends React.PureComponent {
  render() {
    if (!this.props.disabled && this.props.started && !this.props.finished) {
      return (
        <ProgressBar
          progressBarId="saveBarObj"
          progressBarClassName="progress progress-striped active"
          progressId="saveBar"
          progressClassName="bar"
          step={this.props.step}
          totalSteps={this.props.totalSteps}
        />
      );
    }

    return null;
  }
}

StaticBuilderSaveProgressBar.defaultProps = {
  progressBarId: '',
  progressId: '',
  progressBarClassName: '',
  progressClassName: '',
};

StaticBuilderSaveProgressBar.propTypes = {
  disabled: PropTypes.bool.isRequired,
  started: PropTypes.bool.isRequired,
  finished: PropTypes.bool.isRequired,
  step: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
};

const mapStateToProps = ({ AnimationReducer }) => (
  {
    disabled: AnimationReducer[AnimationConstants.STATIC_BUILDER_SAVE_ANIMATION].disabled,
    started: AnimationReducer[AnimationConstants.STATIC_BUILDER_SAVE_ANIMATION].started,
    finished: AnimationReducer[AnimationConstants.STATIC_BUILDER_SAVE_ANIMATION].finished,
    step: AnimationReducer[AnimationConstants.STATIC_BUILDER_SAVE_ANIMATION].step,
    totalSteps: AnimationReducer[AnimationConstants.STATIC_BUILDER_SAVE_ANIMATION].totalSteps,
  }
);

export default ReactRedux.connect(
  mapStateToProps,
)(StaticBuilderSaveProgressBar);



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderSaveProgressBar.jsx